module.exports = __webpack_public_path__ + "static/media/logo_white.cec7febf.svg";